import { FormContextValues } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { preInterviewSettingsTranslationKeys } from '../../../../translations';

import { SENDING_MODES, SendingMode, SendingModeFieldFormBeanPart } from './SendingModeField.types';

const t = preInterviewSettingsTranslationKeys;

const radioGroupItems: RadioGroupItem<SendingMode>[] = SENDING_MODES.map((mode) => ({
   id: mode,
   label: t.sendingModeMap[mode],
}));

type SendingModeFieldProps = Readonly<
   Pick<FormContextValues<SendingModeFieldFormBeanPart>, 'register'> & { disabled: boolean }
>;

export const SendingModeField = (props: SendingModeFieldProps): JSX.Element => {
   return (
      <RadioGroup<SendingMode>
         testId={'sendingMode'}
         label={t.sendingMode}
         controller={props.register('preInterviewSendingMode')}
         items={radioGroupItems}
         disabled={props.disabled}
         horizontal
      />
   );
};
